import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import app from './modules/app';
import mati_config from "@/plugins/store/modules/mati_config";
import security from "@/plugins/store/modules/security";
import documents from "@/plugins/store/modules/documents";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        security,
        mati_config,
        documents
        //TODO: ADD ROUTER MODULES
    },
    state: {
        //YOU CAN DEFINE ALL STATE VARIABLES HERE
    },
    getters: {
        //TO GET STATE
    },
    mutations: {
        //HERE IS WHERE THE STATE CHANGE
    },
    actions: {
        //HERE YOU CAN CALL ASYNC METHODS TO MUTATE THE STATE
    },
    plugins: [createPersistedState({
        //TODO: OBFUSCTATE SECURITY MODULE
        paths: ['security'
            /*TODO: ADD ONLY THE PERSITED MODULES THEY WILL BE STORED ON LOCALSTORAGE BROWSER */],
    })],
});